import { useQuery } from "react-query";
import { setHeaders } from "../../../utils/basic";
import * as config from "../../../app.config";
import axios from "axios";


const getQlpConsumables = async (plate_uuid) => {

    const headerConfig = setHeaders();
    const { data } = await axios.get(`${config.ENDPOINTS["datalake"]}/qlp/qlp_consumables/${plate_uuid}`, {
        headers: headerConfig
    });
    return data;
}


export default function useFetchQlpConsumables(plate_uuid) {

    return useQuery('QlpConsumables', () => getQlpConsumables(plate_uuid), {

        onSuccess: (data) => {
            // console.log(data);
        },
        onError: (error) => {
            console.log(error);
        },

    });

}